<template>
  <div class="content">
    <p class="titp"><strong>一、氧对人体生命的重要意义</strong></p>
    <p>氧是人体不可须臾缺少的“养生之气”，是机体功能活动所需能量来源的重要物质基础，是机体新陈代谢启动机制的关键之一，人体新陈代谢过程中必须有足够的氧，各种营养物质必须同氧结合，才能完成生理氧化过程，产生出能量，所以氧是人体新陈代谢活动的关键物质，是人体生命运动的第一需要。</p>
    <p>人体每分钟耗氧量在0.25-0.30升，其中大脑耗氧占25%左右，心脏耗氧占15%以上，一旦缺氧，首受其害的是大脑和心脏。</p>
    <p>食物、水、空气是人体三大物质基础。事实证明，一般人体在能充分获得氧气的前提下，不食可维持生命7日左右；不食不饮可维持3日左右；但在不能获得氧气的情况下，饮食不缺，却只能维持数分钟。</p>
    <p class="titp"><strong>二、引起人体缺氧的原因</strong></p>
    <p>环境因素：如人处于空气稀薄的高原、矿井或长期呆在密闭的高层办公楼内。</p>
    <p>自身身体因素：如患有某些影响氧气吸收与输送、利用的疾病，如慢性阻塞性肺疾病、心脏血管系统疾病、糖尿病、颈椎病等。</p>
    <p class="titp"><strong>三、缺氧对人体的危害：</strong></p>
    <p>氧气是人体赖以生存的重要物质基础，因此，长期缺氧必然产生一系列的危害：</p>
    <p>缺氧导致体内有氧代谢率下降，糖的无氧酵解加强，机体代谢率降低，免疫力下降；</p>
    <p>缺氧引起肺血管收缩，造成肺动脉高压，右心室负担增加，最终导致肺心病；</p>
    <p>缺氧可加重高血压，加重左心负担，引起心律失常；</p>
    <p>缺氧使得整个身体状况进入一种相互影响的恶性循环状态。缺氧刺激肾脏产生红细胞生成素，使体内细胞增多，血液粘稠度提高，外围血管阻力加大，心脏负担加重，引起或加重心里衰竭，诱发心肌梗塞、脑血栓等；缺氧可引起大脑产生一系列精神、神经症状，如失眠、反应速度下降、记忆力下降、行为异常、个性改变等；缺氧引起肝细胞水肿、变性和坏死，肝功能障碍，肝纤维化；是肾血管收缩，肾小管上皮细胞坏死而导致肾功能不全等；缺氧使得整个身体状况进入一种相互影响的恶性循环状态。</p>
    <p class="titp"><strong>四、专家观点</strong></p>
    <p>“一切疾病的根源是缺氧症”</p>
    <p class="name">—野山英世（日本医学博士）</p>
    <p>“缺氧症导致癌症”</p>
    <p class="name">—Otto Warbtirg (德国诺贝尔医学奖获得者)</p>
    <p>“癌细胞在缺氧细胞中增殖，脑卒中、心脏病、动脉硬化、肝病、子宫颈等成人病的最主要原因也是缺氧”</p>
    <p class="name">——小内山博（日本前劳动科学研究所所长）</p>
    <p>“长期家庭氧疗对COPD（慢性阻塞性肺疾病）缓解期有慢性呼吸衰竭的病人能降低远期的病死率，提高病人的生活质量。”</p>
    <p class="name">——中国基层医药2002年6月28日盘第九卷第九期</p>
    <p class="titp"><strong>五、什么病状需要吸氧：</strong></p>
    <p>1、心血管系统疾病：冠心病、心肌炎、心肌梗塞、动脉粥样硬化、心力衰竭、高血压等疾病</p>
    <p>2、呼吸系统疾病：气管炎、支气管炎、哮喘、肺功能不良、肺炎、肺癌及肺源性心脏病等职业病；睡眠前临睡前吸氧半小时，有助于提高睡眠质量。</p>
    <p>3、孕妇围产期孕妇围产期疾患及胎儿宫内窘迫，孕妇吸氧可使胎儿发育更好。预防早产或新生儿痴呆产生。</p>
    <p class="titp"><strong>六、吸氧的好处：</strong></p>
    <p>吸氧气有如下好处： 1.改善及缓解心脑血管，呼吸系统，心肺功能，高血压，心脏病，慢性肺病等疾病能够的发生及发展。2.缓解底氧吸引的症状，延缓内脏疾病的发生发展，增强新陈代谢。3.改善大脑供氧状况，调节脑神经系统。 4.，尤其是产前两个月，保证胎儿获得足够的氧气，使胎儿更好的发育。
        5.中老年人及亚健康人群的补氧保健；体内参与循环的血液每年都会减少，氧气也会自然减少。6.大运动量后，恢复疲劳。
        7.氧气供应可促进皮肤的血液循环，使皮肤健康，富有弹性。长期使用，可增强记忆力，保持旺盛精力，缓解衰老。随着人们特别是慢病吸氧的关注以及环境的恶化，人们越来越感觉到氧气保健的重要性以及对健康的显著作用。</p>
    <p class="titp">1、氧有助于改善睡眠</p>
    <p>睡眠是一个重要的生理过程，人的一生中大约有1/3的时间是在睡眠中度过的，人在睡眠状态下，全身肌肉松弛、呼吸心率减慢、基础代谢率下降、大脑活动减少，它对人体是一种保护性抑制，失去的是暂时的时间，得到的是次日充沛的精力。人如果得不到充足的睡眠，势必会引起大脑耗氧增加，造成相对性缺氧，人在轻度缺氧时表现为兴奋，兴奋的结果反过来又影响睡眠，最后掉入一个：失眠→缺氧→失眠的恶性循环，吸氧可以打破这种怪圈，还你一个甜美的夜晚。</p>
    <p class="titp">2、氧有助于缓解疲劳</p>
    <p>引起疲劳的原因是多方面的，如体力或脑力的透支，人体的自然衰老，心脑血管及其它疾病的前期或恢复期，手术后的康复期，人体生物周期中的低潮期等，在上述所有原因中，大部分与缺氧有关。氧可促进新陈代谢，利于食物的消化吸收，能及时把它们转换成人体所需要的能量（ATP），让我们保持充沛的体力或精力。</p>
    <p class="titp">3、氧有助于美容光肤</p>
    <p>皮肤的亮泽、弹性直接反映了一个人的精神面貌，对女性朋友显的尤为重要，老人之所以皮肤干燥，无弹性，是由于皮肤衰老，代谢功能下降造成的，皮肤上的汗腺，皮脂腺是保持皮肤光泽的关键，在氧供应充足的情况下，可以延长汗腺或皮脂腺的寿命，从而保持皮肤的光泽和滑润，皮肤的弹性与皮肤的张力及皮下脂肪的状况有关，氧有助于保持这种张力。。国外有人举办专门吸氧的" 青春诊所 " ，认为可使人容光焕发，青春常驻。</p>
    <p class="titp">4、 氧有助于缓解醉酒</p>
    <p>饮酒后大量的乙醇进入体内，乙醇的代谢是在肝脏进行的，在氧的作用下乙醇氧化成乙醛，乙醛在氧化变成乙酸，最后变成二氧化碳和水，分解1分子的酒精,则需要3分子的氧气。在代谢氧化过程中离不开氧的参与，同时释放出能量，所以饮酒后，分解体内的酒精需要很多氧气。或多或少存在一个氧相对缺乏的状态，氧有助于缓解醉酒。</p>
    <p class="titp">5、氧有助于消除吸烟带来的伤害</p>
    <p>人吸烟后查碳氧血红蛋白定性可以为阳性，说明产生的烟雾里含有一氧化碳，一氧化碳进入人体后与氧争夺血红蛋白受体，一氧化碳与血红蛋白的结合力比氧大200倍左右，一旦形成碳氧血红蛋白，就失去了携氧能力，从而造成机体缺氧，在氧比较充足的情况下，可加快碳氧血红蛋白的解离，从而恢复血红蛋白的携氧能力。所以对于平时吸烟的人，如果能生活或工作在一个富氧的环境里，或者间断性的定期吸氧，可以减低吸烟对人体造成的伤害。</p>
    <p class="titp">6、氧有助于预防心脑血管疾病</p>
    <p>心、脑血管疾病严重威胁人类健康，是临床上的常见病、多发病，其中很多疾病与缺血缺氧有关，如冠心病、高血压、动脉硬化、脑供血不足、脑梗赛等，长期慢性缺氧是其发病的原因之一,定期吸氧可在一定程度上延缓或减轻缺氧性心脑血管疾病的发生。</p>
    <p>以冠心病为例，是一缺血缺氧性心脏疾病，定期吸氧起到的是与服用扩冠药一样的作用，能迅速提高血液中的氧含量和氧储备，可延缓心脑功能性改变到器质性病变的过程，同时还可增加红细胞的变形性，降低血液的粘稠度，预防心绞痛、心梗、脑梗等严重病情的发生，只要选择合适的吸氧产品及科学的吸氧方法，不会对人体造成明显副作用。</p>
    <p class="titp">7、氧有助于缓解呼吸系统疾病的缺氧症状</p>
    <p>呼吸系统的任何疾病都会导致肺的通气不足或交换障碍，如气管炎、哮喘、打呼噜等，其结果是进入到身体内的氧减少而缺氧，吸氧由于提高了吸入体内的氧量，可以在一定程度上弥补这种缺氧，降低了由于肺部疾患引起的各种缺氧性疾病的发生率。</p>
    <p class="titp">8、 氧有助于提高人体免疫力</p>
    <p>人体的免疫包括细胞免疫和体液免疫二部分，在氧气供应充足的情况下，有利于免疫物质的产生，增强了免役物质的活性，因此，可以很好的抵御外来致病微生物的入侵。</p>
    <p class="titp">9、氧有助于亚健康的恢复、提高工作效率</p>
    <p>当你读书学习、埋头工作或做各种家务劳动时，都离不开大脑的思维、判断并发出正确的指令，在大脑完成这一系列过程中，需要有充足的能量供给，在产生能量的过程中又需要氧气的持续供应，对于脑力工作者这种感受会更加明显，脑力工作决定了比普通工作需要更多的氧气，长此下去机体会处于相对缺氧状态，经常会感觉头昏脑胀、烦躁、困乏、记忆力下降等，氧会使你思维更敏捷，头脑反应更灵敏，有助于提高你的工作效率。</p>
    <p class="titp">10、氧有助于延年益寿、延缓衰老</p>
    <p>衰老主要表现为毛发变白、皮肤干燥，肤色渐由细嫩红润变为暗褐粗糙，乃至面部、手背、腕部、足背等处出现老年斑。其主要病理特征是心、肝、脾、肺、肾脏腑器官的老化，这种自然衰老都与器官功能衰退有关，氧可以促进新陈代谢，增强器官的功能。</p>
    <p class="titp">11、氧有助于防治老年痴呆</p>
    <p>老年痴呆症是一种常见的慢性进行性精神衰退性疾病，它是由多种原因造成脑缺血缺氧，脑神经细胞变性而出现的大脑慢性功能障碍，以意识模糊、记忆缺损、人格障碍和语言障碍为主要表现。该病导致老年人严重丧失生活自理能力，生活质量明显下降。在众多的发病原因中大部分与缺血缺氧有着直接或间接的关系，神经内科专家经多年研究也证实，老年性痴呆与脑部慢性缺血缺氧有关。</p>
    <p class="titp">12、氧有助于缓解高原缺氧症状</p>
    <p>我国地域辽阔，对于常年工作或短时间停留在我国青、藏、云、贵、川等高原地区的广大干部群众及部队官兵，都面临一个高原缺氧问题，生活在高原地区的人更容易受缺氧性疾病的侵袭，吸氧无疑是最好的保护健康措施。</p>
    <p class="titp">13、氧有助于促进儿童孤独症、神经运动发育迟缓及脑瘫的恢复</p>
    <p>这部分患儿很多存在脑发育迟缓、代谢障碍、免疫力低下、消化不良等问题，部分出生时即有明确的窒息缺氧史，早发现、早干预、早治疗是预后恢复好坏的关键，早期给予恰当氧疗对促进脑神经发育非常重要，无论对认知能力、运动能力、语言能力、平衡能力等均有帮助</p>
    <p class="title"><strong>普及各种常见疾病与氧疗知识</strong></p>
    <p class="title fontcolor"><strong>慢性阻塞性肺病疾病与氧疗</strong></p>
    <p class="titp"><strong>一、何谓慢性阻塞性肺病疾病？其病情发展规律如何？</strong></p>
    <p>慢性阻塞性肺病疾病是一类严重呼吸系统疾病，包括慢性支气管炎、支气管哮喘、肺气肿、肺心病，因此类疾病都有不同程度的气管阻塞、呼吸不畅，统称为慢性阻塞性肺疾病，简称慢阻肺，英文缩写为COPD。</p>
    <p>慢阻肺如果病情控制不到位，身体将呈持续性不可逆式进行性发展，通过由支气管炎、支气管哮喘发展到肺氧肿，再发展到肺心病，肺心病又常因急性感染发作，诱发心功能衰竭、肺功能衰竭，此时，如抢救不及时，容易导致死亡。</p>
    <p class="titp"><strong>二、缺氧——慢性肺患者的直接后果</strong></p>
    <p>慢性肺患者一方面由于气管、支气管收缩，官腔内分泌物增多，导致呼吸道阻塞，呼吸不畅；另一方面由于小支气管的肺泡大量破坏，造成换气功能发生障碍；以上两个方面直接导致患者身体长期处于缺氧状态。</p>
    <p class="titp"><strong>三、慢性肺患者缺氧的主要危害</strong></p>
    <p><strong>氧气是人体的生命之源，是人体生理代谢不可缺少的物质基础，慢性肺患者因呼吸功能障碍导致身体处于长期慢性缺氧状态，从而对身体造成诸多损害：</strong></p>
    <p>1、造成机体代谢效率降低，抵抗力下降，呼吸系统反复感染，加重病情，甚至需要经常住院治疗。</p>
    <p>2、引起心脑血管系统病变，加重高血压，造成心律失常，引起或加重心力衰竭，诱发脑血栓，并可产生一系列精神、神经症状：如失眠、智力下降、记忆力下降、行为失常、个性改变等。</p>
    <p>3、引起其它组织器官出现缺氧性病变，如引起肝细胞水肿、变性和坏死，使转氨酶、乳酸脱氢酶升高，诱发肝纤维化，是肝脏缩小，肝功能障碍；使肾血管收缩，肾小管上皮细胞坏死，继而导致急性肾功能不全等。</p>
    <p>4、使得整个身体状况进入一种相互影响的恶性循环状态。</p>
    <p class="titp"><strong>四、氧疗——慢性肺患者控制与康复的最有效方法</strong></p>
    <p>1、吸氧能阻止病情的进一步发展，延长寿命：医学研究表明，每天坚持家庭氧疗的慢阻肺患者，寿命明显高于未做家庭氧疗的患者。</p>
    <p>2、吸氧能提高全身和呼吸道局部的免疫能力，减少急性呼吸道感染的发生；避免急性肺功能及心功能衰竭。医学资料统计表明，慢阻肺病人在坚持进行家庭氧疗后，因呼吸道并发症而需要争论就医的次数或住院的平均天数都有明显减少，病情亦较轻，而且服药减少，避免长期住院带来的费用负担，照顾麻烦等许多问题。</p>
    <p>3、吸氧能改善病人的生活质量，例如原活动后即气短，生活不能处理的患者经过一段时间的家庭氧疗后，可自行下楼活动，气促症状缓解，精神状况好转，活动能力增加，生活质量明显提高。</p>
    <p class="title fontcolor"><strong>心脑血管系统疾病与氧疗</strong></p>
    <p class="titp"><strong>一、心脑血管系统疾病已成为威胁人类健康的第一大杀手，它具有明显“三高”的特点</strong></p>
    <p>1、高发病率：占人口基数的12%，居各类疾病之首。</p>
    <p>2、高致残率：脑栓塞、脑溢血发病后致残率在70%以上，其中40%重度致残。</p>
    <p>3、高死亡率：占全人类死亡人数的30%以上。</p>
    <p class="titp"><strong>二、心脑血管系统生理及意义</strong></p>
    <p>心血管系统又称为血液循环系统：由心脏和血管两大部分组成。心脏是推动血液流动的动力器官（血泵），而血管则是运输、分配血液及进行物质交换的管道和场所；血液携带养分和氧气通过循环系统到达身体的各个部位器官以供新陈代谢。</p>
    <p class="titp"><strong>三、心脑血管系统疾病的范围和影响</strong></p>
    <p><strong>心脑血管系统疾病主要包括低血压、高血压、动脉硬化、冠心病、心肌梗塞、心律失常、心力衰竭、脑血栓、脑溢血等。</strong></p>
    <p><strong>心脑血管系统疾病前期控制不佳，各病种之间呈持续进行性发展，如高血压、动脉硬化得不到控制，发展到一定阶段：</strong></p>
    <p>影响到心脏，会出现冠心病，心律失常、心力衰竭、心肌梗塞。影响到脑部，就出现脑血栓、脑溢血。还可能影响到肾脏，出现肾衰竭。</p>
    <p class="titp"><strong>四、心脑血管系统疾病引起的缺氧症状</strong></p>
    <p>心脑血管系统一旦出现病变，血液运输出现障碍，人体就不能获得新陈代谢所需的充足氧气，必然出现一系列的症状与病变：头痛、头晕、失眠、记忆力下降、智力阻碍、心悸、胸闷、心绞痛等。一旦病情急性发作，抢救不及时，则导致心脏死亡、脑死亡而危及人的生命。</p>
    <p class="titp"><strong>五、心脑血管系统疾病患者进行家庭氧疗的意义</strong></p>
    <p><strong>吸氧能提高血液中的氧含量，从而：</strong></p>
    <p>1、促进血脂分解，降低血脂水平。</p>
    <p>2、促进血管中血栓的分解，疏通血管。</p>
    <p>3、提高血管壁细胞新陈代谢的水平，软化血管。</p>
    <p>4、改善心脏自身血氧不足导致的心律失常、心绞痛等症状。</p>
    <p>5、改善心脏自身功能，提高心脏供血能力。</p>
    <p>6、改善因供血供氧不足导致的各组织缺血却氧性症状。</p>
    <p>7、在一定程度上预防冠心病、脑动脉硬化而导致的心肌梗塞、脑溢血等突发性疾病的发生。</p>
    <p>8、对于突然发作的心肌梗塞、脑血栓、脑溢血病人，及时吸氧可及时控制和缓解病情，并为住院抢救赢得时间。</p>
    <p class="title fontcolor"><strong>糖尿病与氧疗</strong></p>
    <p class="titp"><strong>一、何谓糖尿病？</strong></p>
    <p>糖尿病又叫消渴病，是由于各种原因引起的人体胰脏内胰岛功能减退导致胰岛素分泌减少从而体内糖、脂肪、蛋白质等代谢发生紊乱，血糖升高的一类老年人常见疾病。糖尿病的典型症状是“三多一少”，即多饮、多食、多尿、体重减轻，同时还伴有疲乏无力、皮肤或会阴瘙痒等。</p>
    <p class="titp"><strong>二、糖尿病的并发症</strong></p>
    <p><strong>糖尿病如控制不好，血液中的血红蛋白高度氧饱和，而物理溶解氧量下降，导致血液输送氧气的能力降低，组织细胞缺氧，产生一系列并发症：</strong></p>
    <p>1、影响到心脑血管，如高血压、高血脂、动脉硬化、冠心病、心肌梗塞、脑血栓、脑溢血等，如累及周围血管，可出现下肢疼痛、感觉异常和间隙性破坏等，严重的可发生脚坏死。</p>
    <p>2、影响视网膜血管，则会发生白内障，出现视力障碍，甚至失明。</p>
    <p>3、影响神经系统，可使末梢神经出现病变，产生肢体疼痛，感觉异常。</p>
    <p>4、严重的糖尿病人，可能引起酮症、酸中毒而昏迷。</p>
    <p class="titp"><strong>三、氧疗对糖尿病的意义</strong></p>
    <p><strong>现代医学研究表明，氧疗对糖尿病具有重要意义，主要在于：</strong></p>
    <p>1、吸氧是血氧含量增加，有氧代谢旺盛，葡萄糖消耗增多，血糖可因此而下降。</p>
    <p>2、吸氧使体内有氧代谢增加，三磷酸腺苷生成增多，能促进胰岛功能恢复。</p>
    <p>3、吸氧使血液物理溶解氧量增加，输送到身体各部位的氧量增加，组织缺氧得以纠正，由缺氧引起的一系列并发症得到缓解。</p>
    <p class="titp"><strong>四、曾有医学研究人员对一组糖尿病患者进行单纯吸氧，观察吸氧后血糖及尿糖的变化，具体方法为</strong></p>
    <p>病人每日吸氧（浓度为90%以上医用氧）2-4次，每次1-2小时，流量确定为2升/分钟，经过3周后观察，血糖、尿糖均明显下降，有的甚至恢复正常，同时症状显著减轻，长期应用未见到任何副作用。</p>
    <p><strong>注：糖尿病治疗要想达到最佳疗效，最好是药物治疗+食疗+氧疗</strong></p>
    <p class="title fontcolor"><strong>颈椎病与氧疗</strong></p>
    <p class="titp"><strong>一、何谓颈椎病？</strong></p>
    <p>颈椎病是指由于颈椎骨质增生而形成骨刺，骨刺压迫椎动脉，使供血受阻，导致脑组织缺氧，出现失眠、头晕、恶心、呕吐、肢体麻木、颈部不适症状的一种疾病。</p>
    <p><strong>二、氧疗对颈椎病治疗的意义</strong></p>
    <p>1、吸氧能增加血氧含量，改善脑组织缺氧状况，减轻眩晕症状，改善失眠、头晕等症状。</p>
    <p>2、吸氧能改善颈椎组织自身制氧状态，防止颈椎骨组织继续退化和钙化，使关节及韧带活动不受影响，防止肌肉萎缩，在临床上起到积极的作用。</p>
    <p class="title fontcolor"><strong>失眠与氧疗</strong></p>
    <p class="titp"><strong>一、失眠的危害</strong></p>
    <p><strong>睡眠对任何人来说都是必不可少的，它是维持生命的极其重要的生理功能。如果一旦失眠，则对人体的损害影响极大：</strong></p>
    <p>1、在神经精神活动方面，如感觉疲乏、注意力不集中、记忆力差、反应迟钝、情绪不稳定、易激动、或情感淡漠、对外界环境丧失兴趣。</p>
    <p>2、动作行为变得粗超、忙碌、缺乏条理。</p>
    <p>3、肌体不适感增多，如出现头昏脑胀、视力模糊、耳鸣重听等。</p>
    <p>4、人体免疫力降低，易生病，而患病者如果睡眠不佳，则病情将一步步加重。</p>
    <p class="titp"><strong>二、失眠的种类</strong></p>
    <p><strong>失眠发生时间长短，可分为：</strong></p>
    <p>1、一过性失眠：指偶尔失眠</p>
    <p>2、短期失眠：指为期2</p>
    <p>3、慢性失眠：通常指病程在6个月以上的经常性失眠</p>
    <p class="titp"><strong>三、失眠的病因</strong></p>
    <p><strong>失眠病因繁多，病程长短不同的失眠原因往往也不相同：</strong></p>
    <p>1、一过性失眠：多由环境因素改变或外界干扰引起，如旅游、搬迁、噪音、酷暑、寒冷、蚊虫叮咬等引起，此外，一时性的过渡反应也是常见病因。干扰因素的去除或对新环境的适应可使睡眠恢复正常。</p>
    <p>2、短期失眠：精神紧张，如思考过度、情绪焦虑不安等，以及躯体不适是其产生的原因。精神因素解决或躯体疾病痊愈，失眠也多痊愈。</p>
    <p>3、慢性失眠：原因复杂，也无统一的分类标准，总的来说，与患者本身的易感素质和一定的外在特定条件有关。但据医学专家研究表明，70%以上的慢性失眠患者在睡眠过程中都存在低氧血症，即血氧饱和度偏低，不能满足大脑及其它组织新陈代谢对氧的需求，大脑因缺氧出现亢奋状态，从而导致失眠。事实上大多数慢性失眠患者有某种特定的能影响氧的吸收与输送的疾病也可以证明这点。</p>
    <p><strong>四、氧疗对失眠患者的意义</strong></p>
    <p>1、通过吸氧，能提高血氧饱和度，使身体各组织部分获得充足的氧，从而促进新陈代谢，使身体各个部分特别是大脑充分放松，容易入睡并保持最佳的睡眠状态，从而缓解由精神紧张或身体不适引起的失眠。</p>
    <p>2、通过吸氧，能改善各种疾病因素引起的人体缺氧状态，改善人体低氧血症，使得大脑及各组织获得充足的氧，新陈代谢趋于正常，功能改善，从而睡眠质量提高。</p>
    <p class="titp"><strong>一、何谓胎儿宫内窘迫？</strong></p>
    <p>胎儿宫内窘迫就是指胎儿在母体内缺氧。</p>
    <p class="titp"><strong>二、形成胎儿宫内窘迫原因</strong></p>
    <p><strong>胎儿在母体子宫内缺氧可以是慢性的，也可能是急性的，其原因较多，主要在以下几点：</strong></p>
    <p>1、某些孕妇患有心、肺、肾等慢性疾病，自身缺血缺氧，必然导致胎儿缺血缺氧。</p>
    <p>2、胎盘功能不良，营养物和氧不能渗透到胎儿体内，造成胎儿营养不良，缺血、缺氧。</p>
    <p>3、孕妇分娩时因脐带过短、打结、缠绕、脱垂等导致胎儿急性缺氧。</p>
    <p>4、产妇难产或产程过长，未得到及时处理或处理不当，也会引起胎儿缺氧。</p>
    <p>5、由于母子血型不合引起胎儿溶血，也可以引起胎儿缺氧。严重时（由于胎儿溶血量大）可造成胎儿死于宫内。</p>
    <p class="titp"><strong>三、胎儿宫内窘迫有何危害？</strong></p>
    <p>1、由于胎儿宫内缺氧，损伤大脑，很有可能导致胎儿出生智力低下、反应迟钝、呆傻、甚至成为终身残疾；严重者可造成流产、早产、胎死宫内。</p>
    <p>2、对于患有心、肺、肾等慢性疾病的孕妇，由于妊娠加重了心、肺、肾等脏器的负担，有可能导致心、肺、肾等器官功能衰竭，从而出现生命危险。</p>
    <p><strong>四、氧疗对胎儿宫内窘迫有何意义</strong></p>
    <p><strong>对于各种原因、各种程度的胎儿宫内缺氧，都应给孕妇补充氧气：</strong></p>
    <p>1、吸氧对于患有心、肺、肾等疾病的孕妇来说，可避免功能的衰竭</p>
    <p>2、吸氧能增加孕妇血氧浓度，并通过胎盘血流将氧带给胎儿，打断胎儿制氧过程，改善胎儿生长发育环境，延长胎儿在母体生长的时间，以保证胎儿顺利发育成熟。</p>
    <p>3、吸氧可为胎儿顺利分娩、胎儿出生后的健康和智力打下基础。</p>
    <p class="title fontcolor"><strong>氧疗氧保健相关知识解答</strong></p>
    <p class="titp"><strong>一、吸氧会不会成瘾？</strong></p>
    <p>氧气作为人体新陈代谢的物质基础之一，一旦缺乏，必将导致人体新陈代谢异常，出现各种病理反应；同时氧疗作为现代医学应用非常广泛的一种治疗手段，主要功效在于纠正人体因各种外在或内在因素而导致的身体缺氧状态，从而达到治疗疾病的目的，一旦人体缺氧的因素去除，便可停止吸氧，此时对身体决无不良反应。但问题是人体许多疾病如肺气肿、肺心病、脑溢血等病情不可逆转，其所导致身体缺氧状态也就无法改变，所以必须长期坚持进行氧疗，但这绝不说明人体会吸氧成瘾。</p>
    <p class="titp"><strong>二、何谓氧中毒？如何预防？</strong></p>
    <p>长时间、高流量吸氧（指吸入浓度为90以上氧气，流量＞5升/分）,从而导致肺泡中氧浓度过高,使得肺泡及人体出现各种损害性病变,称为氧中毒.</p>
    <p>注:肺泡中氧浓度计算公式为:肺泡中氧浓度(%)=21+4ｘ给氧流量(升/分钟),但如果吸入90%以上的氧气流量控制在1-3升/分钟之间,则肺泡氧浓度在25-33%之间,符合肺泡中气体交换的最佳浓度,是绝不会发生氧中毒的。</p>
    <p class="titp"><strong>三、氧疗有何注意事项</strong></p>
    <p>1、氧流量不宜过高或过低,过高会造成二氧化碳在体内滞留,加重病情;过低则达不到氧疗效果,正确的吸氧流量应该2升/分钟左右.</p>
    <p>2、必须根据病情确定每天氧疗时间</p>
    <p>3、氧源应符合医疗标准,质量必须可靠</p>
    <p>4、必须根据病情,长期坚持进行氧疗</p>
    <p class="titp"><strong>四、如何根据病情状况,确定每天氧疗时间?</strong></p>
    <p>1、慢性阻塞性肺疾病(慢性支气管炎、支气管哮喘、肺气肿、肺心病等)患者每天累计吸氧时间最好在15小时以上。</p>
    <p>2、心脑血管系统疾病（高血压、高血脂、动脉硬化、冠心病、心律失常、脑血栓等）、颈椎病患者建议每天分早晨、下午、晚上三次吸氧，每次一小时左右。</p>
    <p>3、糖尿病人建议每日吸氧2-4次，每次1-2小时，分别安排在早上、上午、下午、晚上。</p>
    <p>4、失眠患者最好在临睡前吸氧1-2小时</p>
    <p>5、宫内胎儿窘迫型孕妇可每天早上起床后及晚上临睡前各吸1小时氧</p>
    <p>6、亚健康状态、美容每次吸氧在30-60分钟，一天1-2次</p>
    <p>7、重病患者、抢救病人需要24小时不间断吸氧</p>
  </div>
</template>

<script>
export default {
  name: 'TabOxygenTherapyBenefits'
}
</script>

<style lang="scss" scoped>
.content {
  font-size: 18px;
  color: #6a6a6a;
  p {
    line-height: 36px;
    text-indent: 40px;
  }
  .title{
    text-align: center;
    font-size: 20px;
  }
  .fontcolor{
    color: blue;
  }
  .titp{
    text-indent: 0px;
    font-size: 20px;
    font-weight: 700;
  }
  .name{
    text-align: right;
  }
}
</style>
